import Vue from 'vue'

export default Vue.directive('ripple', {
  inserted: function (el, binding, vnode) {
    if (!binding.value) return

    createHover(el)

    el.addEventListener('mouseenter', hover)
    el.addEventListener('mousedown', startRippleEffect)
    el.addEventListener('mouseup', endRippleEffect)
    el.addEventListener('mouseleave', endRippleEffectAndHover)
  },
})

function createHover(el: any) {
  const target = el
  target.style.overflow = 'hidden'
  const circle = document.createElement('span')

  circle.classList.add('hds-ripple-hover')
  circle.style.width = `${target.clientWidth}px`
  circle.style.height = `${target.clientHeight}px`
  circle.style.left = '0px'
  circle.style.top = '0px'

  target.appendChild(circle)
}

function hover(event: any) {
  const target = event.currentTarget
  const circles = [...target.getElementsByClassName('hds-ripple-hover')] || []
  for (let i = 0; i < circles.length; i++) {
    circles[i].classList.toggle('hds-ripple-hover--show')
  }
}

function startRippleEffect(event: any) {
  const target = event.currentTarget
  target.style.overflow = 'hidden'

  const offset = target.getBoundingClientRect()
  const circle = document.createElement('span')
  const diameter = Math.max(target.clientWidth, target.clientHeight)
  const radius = diameter / 2

  circle.classList.add('hds-ripple-circle')
  circle.style.width = circle.style.height = `${diameter}px`
  if (!target.classList.contains('ripple--center')) {
    circle.style.left = `${event.clientX - offset.left - radius}px`
    circle.style.top = `${event.clientY - offset.top - radius}px`
  } else {
    circle.style.left = '0px'
    circle.style.top = '0px'
  }
  setTimeout(() => {
    circle.classList.add('hds-ripple-circle--expand')
  }, 100)

  target.appendChild(circle)
}

function endRippleEffectAndHover(event: any) {
  const target = event.currentTarget
  const circles =
    [
      ...target.getElementsByClassName('hds-ripple-circle'),
      ...target.getElementsByClassName('hds-ripple-hover'),
    ] || []
  for (let i = 0; i < circles.length; i++) {
    if (circles[i].className.includes('hds-ripple-hover')) {
      circles[i].classList.toggle('hds-ripple-hover--show')
      continue
    } else circles[i].classList.add('hds-ripple-circle--disappear')

    setTimeout(() => {
      try {
        circles[i].remove()
      } catch {
        return
      }
    }, 300)
  }
}

function endRippleEffect(event: any) {
  const target = event.currentTarget
  const circles = target.getElementsByClassName('hds-ripple-circle') || []
  for (let i = 0; i < circles.length; i++) {
    circles[i].classList.add('hds-ripple-circle--disappear')
    setTimeout(() => {
      try {
        circles[i].remove()
      } catch {
        return
      }
    }, 300)
  }
}
